import useI18n from '@/shared/hooks/useI18n'
import { Logo } from '@/common'
import { useMemo } from 'react'
import { EntityConfig } from './FinalizedReportPreviewEmbedded'

export default function FinalizedReportFooter({
  selectedPdfLanguage,
  entityConfig,
  pageNumber,
  totalPage
}: {
  selectedPdfLanguage?: string
  entityConfig: EntityConfig
  pageNumber: string
  totalPage: string
}) {
  const { t } = useI18n()
  const tLng = useMemo(() => ({ lng: selectedPdfLanguage }), [selectedPdfLanguage])

  const showUnofficialFooter = !!selectedPdfLanguage && !selectedPdfLanguage.includes('en-GB')

  return (
    <footer id="footer" className="print-footer text-xs text-text-secondary text-center border-t pt-4 px-2 mt-auto">
      <div className="flex justify-between items-start">
        <Logo className="w-20 h-auto" />
        <p className="text-xs">
          {entityConfig.entityName} - {entityConfig.street}
          <br />
          {entityConfig.city}, {entityConfig.country}
          <br />
          {showUnofficialFooter && t('finalizedReportDocument:footer.unofficial', tLng)}
        </p>
        <p className="text-right italic mt-2">
          Page {pageNumber}/{totalPage}
        </p>
      </div>
    </footer>
  )
}
